import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ba from "./languages/bh.json";
import hr from "./languages/hr.json";
import sr from "./languages/sr.json";
import en from "./languages/en.json";

import type TranslateTypes from "./languages/translateTypes";

type CustomTypeOptions = {
  bh: { translation: TranslateTypes };
  hr: { translation: TranslateTypes };
  sr: { translation: TranslateTypes };
  en: { translation: TranslateTypes };
};

const resources: CustomTypeOptions = {
  bh: {
    translation: ba,
  },
  hr: {
    translation: hr,
  },

  sr: {
    translation: sr,
  },
  en: {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  debug: false,
  interpolation: {},
  keySeparator: false,
  lng: "bh",
  resources: resources,
});

export default i18n;
